import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

type QueryParams<T extends string> = {
  [key in T]: string | undefined;
};

export function useQueryParams<T extends string>(keys: T[], prefix: string | null): QueryParams<T> {
  const [params] = useSearchParams();

  // CUSTOM:TAG:CHANGE - I memoized this
  const result = useMemo(() => {
    // Use a type assertion to initialize the result
    const toReturn = {} as QueryParams<T>;

    keys.forEach((key) => {
      const prefixedKey = getPrefixedQueryParamKey(key, prefix);
      const value = params.get(prefixedKey) || undefined;

      toReturn[key] = value;
    });
    return toReturn;
  }, [params]);

  return result;
}

export function getPrefixedQueryParamKey(key: string, prefix: string | null) {
  return prefix ? `${prefix}_${key}` : key;
}
